"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  bodyActive: true,
  loaded: false
};

var AppState = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(AppState, _Record);

  function AppState() {
    (0, _classCallCheck2.default)(this, AppState);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppState).apply(this, arguments));
  }

  (0, _createClass2.default)(AppState, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new AppState(data);
    }
  }]);
  return AppState;
}((0, _immutable.Record)(DEFAULTS));

exports.default = AppState;
module.exports = exports.default;